// @flow
import getAppConfig from 'api/getAppConfig';
import { put, call, take } from 'redux-saga/effects';
import { requestAppConfig, receiveAppConfig } from './appConfigActions';

export default function* appConfigSaga(): Generator<*, *, *> {
  const { payload: token } = yield take(requestAppConfig);
  try {
    const data = yield call(getAppConfig, token);
    yield put(receiveAppConfig(data));
  } catch (err) {
    yield put(receiveAppConfig(err));
  }
}



// WEBPACK FOOTER //
// ./src/ducks/appConfigSaga.js